<template>
  <slot
    :download="downloadCb"
  />
</template>

<script setup lang="ts">
import { IMFile } from '@wui/im'

import { download } from '@/shared/utils/download-files'

const props = defineProps<{
  files: IMFile | IMFile[]
  pathName?: string
}>()

const downloadCb = () => {
  download(props.files, props.pathName)
}
</script>
